import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PeopleIcon from '@material-ui/icons/People';
import RoomIcon from '@material-ui/icons/LocalHotel';
import LaundryIcon from '@material-ui/icons/LocalLaundryService';
import PetsIcon from '@material-ui/icons/Pets';
import WifiIcon from '@material-ui/icons/Wifi';
import ChildIcon from '@material-ui/icons/ChildFriendly';
import WcIcon from '@material-ui/icons/Wc';
import ParkingIcon from '@material-ui/icons/LocalParking';
import CuisineIcon from '@material-ui/icons/Kitchen';
import GardenIcon from '@material-ui/icons/LocalFlorist';
import BeachIcon from '@material-ui/icons/BeachAccess';
import CommercesIcon from '@material-ui/icons/LocalGroceryStore';
import SatelliteIcon from '@material-ui/icons/Satellite';





import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    color: theme.palette.text.primary,
  },
  icon: {
    margin: theme.spacing.unit,
    fontSize: 32,
  },
});

function PrestationsResume(props) {
  const { classes } = props;
  return (
    <Grid container className={classes.root} alignItems="center">
      <Grid item>
        <PeopleIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">9 Couchages</Typography>
      </Grid>

      <Grid item>
        <RoomIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">5 Chambres</Typography>
      </Grid>
      
      <Grid item>
        <PetsIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Animaux acceptés</Typography>
      </Grid>

      <Grid item>
        <ChildIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Enfants</Typography>
      </Grid>

      <Grid item>
        <WifiIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Wifi</Typography>
      </Grid>

      <Grid item>
        <LaundryIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Lave linge</Typography>
      </Grid>

      <Grid item>
        <WcIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">2 Salles de bain, 2 Wc </Typography>
      </Grid>

      <Grid item>
        <CommercesIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Commerces à proximité </Typography>
      </Grid>

      <Grid item>
        <CuisineIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Cuisine aménagée</Typography>
      </Grid>

      <Grid item>
        <ParkingIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Garage </Typography>
      </Grid>

      <Grid item>
        <GardenIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Jardin </Typography>
      </Grid>

      <Grid item>
        <BeachIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Plage à 250m </Typography>
      </Grid>


      <Grid item>
        <SatelliteIcon className={classes.icon} />
     </Grid>
      <Grid item>
        <Typography variant="subheading"  gutterBottom  align="left">Bouquet TV</Typography>
      </Grid>




   
     </Grid>
  );
}

PrestationsResume.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PrestationsResume);



// WEBPACK FOOTER //
// ./src/PrestationsResume.js